import { MaterialModalMsdsField } from "@/components/manufacturing/MaterialModalMsdsField";
import { useMsdsClassifySuggestion } from "@/components/manufacturing/useMsdsClassifySuggestion";
import type { MfgMsdsStatus } from "@/lib/manufacturing/msdsStatus";

type Props = {
  name: string;
  category: string;
  unit: string;
  vendor: string;
  msdsStatus: MfgMsdsStatus;
  onMsdsStatusChange: (next: MfgMsdsStatus) => void;
};

/** MSDS-2 — owns debounced classify + triage strip for the material modal. */
export function MaterialModalMsdsSection({
  name,
  category,
  unit,
  vendor,
  msdsStatus,
  onMsdsStatusChange,
}: Props) {
  const classifyReady = Boolean(name.trim() && category.trim());
  const { classification, loading, error } = useMsdsClassifySuggestion({
    name,
    category,
    unit,
    vendor,
    enabled: classifyReady,
  });

  return (
    <MaterialModalMsdsField
      value={msdsStatus}
      onChange={onMsdsStatusChange}
      classification={classification}
      classifyLoading={loading}
      classifyError={error}
      classifyReady={classifyReady}
    />
  );
}
